import { render, staticRenderFns } from "./radio-group.vue?vue&type=template&id=b25bf4ba&"
import script from "./radio-group.vue?vue&type=script&lang=js&"
export * from "./radio-group.vue?vue&type=script&lang=js&"
import style0 from "./radio-group.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b25bf4ba')) {
      api.createRecord('b25bf4ba', component.options)
    } else {
      api.reload('b25bf4ba', component.options)
    }
    module.hot.accept("./radio-group.vue?vue&type=template&id=b25bf4ba&", function () {
      api.rerender('b25bf4ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/radio-group/radio-group.vue"
export default component.exports